import type { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

export const categories = {
    ['BestCards']: {
        path: 'all-cards',
        name: 'All Cards',
    },
    ['BalanceTransfer']: {
        path: 'balance-transfer',
        name: 'Balance Transfer',
    },
    ['Cashback']: {
        path: 'cashback',
        name: 'Cashback',
    },
    ['PoorCredit']: {
        path: 'credit-cards-bad-credit',
        name: 'Poor Credit',
    },
    ['Purchase']: {
        path: 'purchase',
        name: '0% Purchases',
    },
    ['Rewards']: {
        path: 'rewards',
        name: 'Rewards',
    },
    ['Combined']: {
        path: '0-percent',
        name: 'Balance & Purchases',
    },
    ['Travel']: {
        path: 'travel',
        name: 'Travel',
    },
} as const

export const allCreditCardProductCategories = Object.keys(
    categories
) as CreditCardProductCategory[]

export const categoryPaths = Object.keys(categories).map(
    category => categories[category as keyof typeof categories].path
)

export type CategoryPath = (typeof categories)[keyof typeof categories]['path']
